import { combineReducers } from 'redux';

import { authentication } from './authentication.reducer';
import { registration } from './registration.reducer';
import { users } from './users.reducer';
import { alert } from './alert.reducer';
import chatReducer from './chat.reducer';
import blockedwordReducer from './blockedword.reducer';
import studentReducer from './students.reducer';
import profileReducer from './profile.reducer';
import gameReducer from './game.reducer';
import configReducer from './config.reducer';
import pointsReducer from './points.reducer';
import fontReducer from './font.reducer';

const rootReducer = combineReducers({
  authentication: authentication,
  registration: registration,
  users: users,
  alert: alert,
  chatmessages: chatReducer,
  blockedwords: blockedwordReducer,
  studentslist: studentReducer,
  myprofile: profileReducer,
  mypoints: pointsReducer,
  games: gameReducer,
  config: configReducer,
  fonts: fontReducer
});

export default rootReducer;